export default __webpack_public_path__ + "static/media/under-construction.26365ff2.svg";